import { Select } from 'plume-ui';
import { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useEmailLanguages from '../../hooks/useEmailLanguages';

interface EmailLanguageSelectProps {
  value?: string;
  onChange?: (value: string) => void;
}

const EmailLanguageSelect = ({ value, onChange }: EmailLanguageSelectProps) => {
  const { t } = useTranslation();

  const { data: languages, isLoading: loadingLanguages } = useEmailLanguages();

  const languageOptions = useMemo(() => {
    return (languages || []).map((lang) => ({
      label: `${lang.icon} ${lang.name}`,
      value: lang.code,
    }));
  }, [languages]);

  // Set default value to 'en' if no value is set
  useEffect(() => {
    if (languages && !value && !loadingLanguages) {
      const defaultLanguage = 'en';
      onChange?.(defaultLanguage);
    }
  }, [languages, value, loadingLanguages]);

  // Don't render the Select if there's only one language
  if (languages && languages.length <= 1) {
    return null;
  }

  return (
    <Select
      options={languageOptions}
      loading={loadingLanguages}
      placeholder={t('configuration.emails.selectLanguage')}
      onChange={(value) => onChange?.(value as string)}
      value={value}
    />
  );
};

export default EmailLanguageSelect;
